module.exports = "<div class=\"alert-box\" ng-class=\"$ctrl.type\"><ng-transclude></ng-transclude></div>";